import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { SidenavCategory } from 'src/app/models/menu-item';
import { MenuRevolution } from 'src/app/models/menu/menu.model';
import { SidebarDirective } from 'src/app/nitro/directives/sidebar/sidebar.directive';
import { ThemeService } from 'src/app/nitro/services/theme.service';
import { checkRouterChildsData } from 'src/app/nitro/utils/check-router-childs-data';
import { SidenavService } from 'src/app/services/sidenav.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent implements OnInit,  OnDestroy  {

  @ViewChild('configPanel', { static: true }) configPanel: SidebarDirective | undefined;

  sidenavOpen$ = this.sidenavService.open$;
  sidenavMode$ = this.sidenavService.mode$;
  sidenavCollapsed$ = this.sidenavService.collapsed$;
  sidenavExpanded$ = this.sidenavService.expanded$;
  quickPanelOpen: boolean = false;
  allowsidePage: boolean = false;

  sideNavigation$ = this.themeService.config$.pipe(map(config => config.navigation === 'side'));
  topNavigation$ = this.themeService.config$.pipe(map(config => config.navigation === 'top'));
  toolbarVisible$ = this.themeService.config$.pipe(map(config => config.toolbarVisible));
  toolbarPosition$ = this.themeService.config$.pipe(map(config => config.toolbarPosition));
  footerPosition$ = this.themeService.config$.pipe(map(config => config.footerPosition));

  scrollDisabled$ = this.router.events.pipe(
    filter((event:any) => event instanceof NavigationEnd),
    startWith(null),
    map(() => checkRouterChildsData(this.router.routerState.root.snapshot, data => data.scrollDisabled))
  );

  items: SidenavCategory[] = [];
  itemsRevolution: MenuRevolution[] = [];

  constructor(private readonly sidenavService: SidenavService,
              private readonly themeService: ThemeService,
              private readonly router: Router) {}

  ngOnInit() {
    this.sidenavService.itemsRevolution$.subscribe( (x: any) => {
      this.itemsRevolution = x;
    }
  )
    this.sidenavService._allUrlFind$.subscribe((x: boolean) => {
      if (x) {
        if (!this.sidenavService.allowedUrl()){
          this.allowsidePage = false;
          this.router.navigate(['./unauthorized']);
        } else {
          this.allowsidePage = true;
        }
      }
    })

    this.sidenavService._allUrlFind$.subscribe((x: boolean) => {
      if (x) {
        if (!this.sidenavService.allowedUrl()){
          this.allowsidePage = false;
          this.router.navigate(['./unauthorized']);
        } else {
          this.allowsidePage = true;
        }
      }
    })

  }

  openQuickPanel() {
    this.quickPanelOpen = true;
  }

  openConfigPanel() {
    if (this.configPanel) {
      this.configPanel.open();
    }
  }

  closeSidenav() {
    this.sidenavService.close();
  }

  openSidenav() {
    this.sidenavService.open();
  }

  ngOnDestroy(): void { /* TODO document why this method 'ngOnDestroy' is empty */ }

}
